import React from "react"
import Portrait from "./portrait"
import FiguresDepeindre from "./figures-depeindre"
import FiguresVoyager from "./figures-voyager"
import FiguresImaginer from "./figures-imaginer"
import FiguresTransmettre from "./figures-transmettre"
import { CSSTransition } from 'react-transition-group';
import AirScroll from "./air-scroll";

const Section = ({ id, classes, children }) => {
  return (
    <section
      id={id}
      className={`section section--right ${classes}`}
    >
      {children && children}
    </section>
  )
}

export default ({ active, size }) => {
  const sections = []

  sections.push(<Section id="section-right-1" classes="section--grey section--header">
    <AirScroll speed={1.75}>
      <div className="section__portrait">
        <Portrait />
      </div>
    </AirScroll>
  </Section>)
  sections.push(<Section id="section-right-2" classes="section--introduction section--grey" />)
  sections.push(<Section id="section-right-3" classes="section--green">
    <FiguresDepeindre size={size} />
  </Section>)
  sections.push(<Section id="section-right-4" classes="section--red">
    <FiguresVoyager size={size} />
  </Section>)
  sections.push(<Section id="section-right-5" classes="section--blue">
    <FiguresImaginer size={size} />
  </Section>)
  sections.push(<Section id="section-right-6" classes="section--yellow">
    <FiguresTransmettre size={size} />
  </Section>)
  sections.push(<Section id="section-right-7" classes="section--grey" />)

  return (
    <div>
      {sections.map((section, i) => <CSSTransition
        key={`section-right-${i + 1}`}
        in={active === i + 1}
        timeout={{
          appear: 600,
          enter: 600,
          exit: 600,
        }}
        unmountOnExit
        classNames="fade"
      >
        {section}
      </CSSTransition>)}
    </div>
  )
}
